"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DamageTypeToDamageResistance = void 0;
const AttributeType_1 = require("../enums/AttributeType");
const DamageType_1 = require("../enums/DamageType");
exports.DamageTypeToDamageResistance = {
    [DamageType_1.DamageType.Chaos]: AttributeType_1.AttributeType.ChaosDamageResistance,
    [DamageType_1.DamageType.Death]: AttributeType_1.AttributeType.DeathDamageResistance,
    [DamageType_1.DamageType.Fire]: AttributeType_1.AttributeType.FireDamageResistance,
    [DamageType_1.DamageType.Frost]: AttributeType_1.AttributeType.FrostDamageResistance,
    [DamageType_1.DamageType.Holy]: AttributeType_1.AttributeType.HolyDamageResistance,
    [DamageType_1.DamageType.Nature]: AttributeType_1.AttributeType.NatureDamageResistance,
    [DamageType_1.DamageType.Physical]: AttributeType_1.AttributeType.PhysicalDamageResistance,
    [DamageType_1.DamageType.Sonic]: AttributeType_1.AttributeType.SonicDamageResistance,
    [DamageType_1.DamageType.All]: AttributeType_1.AttributeType.AllDamageResistance,
    [DamageType_1.DamageType.None]: AttributeType_1.AttributeType.None,
};
